// @@BUG: import { supabase } from '@/lib/database/supabase'
import { createClient } from '@/utils/saas/supabase/client'
import { APIOptionsGET, APIOptionsPOST } from '@/lib/APIOptions'
import { Employee, ExportFilterEmployee } from './Employee.types'

// @@TODO: Wrap all database queries in useQuery / useMutation hooks
// @@BUG:
/*
Conversion of type 'undefined' to type 'Employee[]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
Type 'undefined' is not comparable to type 'Employee'.ts(2352)
*/

// NOTE: For each query, pay attention to the effects of any active RLS policy.

// @@TODO: Convert PostgrestError to generic error.

/*
export interface Employee {
  id: number
  name: string | null
  title: string | null
  status: string | null
  age: number
  role: string | null
  imgUrl: string | null
}

export type ExportFilterEmployee = {
  id: number
  name: string
  status: string
}
*/

export function prepareForExport(
  selection: Employee[],
): ExportFilterEmployee[] {
  const filter: ExportFilterEmployee[] = selection.map((row) => {
    const item: ExportFilterEmployee = {
      id: row.id,
      name: row.name,
      status: row.status,
    }
    return item
  })
  console.log('exportFilter=', filter)
  return filter
}

export const initialEmployee: Employee = {
  id: 0,
  name: 'John Doe',
  title: 'manager',
  status: 'open',
  age: 50,
  role: 'back-end',
  imgUrl: 'https://cdn.pixabay.com/photo/2015/03/04/22/35/head-659650_1280.png',
}

export const otherEmployee: Employee = {
  id: 0,
  name: 'Laetitia Casta',
  title: 'Mrs. Obelix',
  status: 'married',
  age: 60,
  role: 'Falballa',
  imgUrl: 'https://cdn.pixabay.com/photo/2015/03/04/22/35/head-659650_1280.png',
}

// OK
export const updateEmployee = async (employee: Employee, id: number) => {
  try {
    const { data, error } = await createClient()
      .from('employees')
      .update({
        name: employee.name,
        title: employee.title,
        status: employee.status,
        age: employee.age,
        role: employee.role,
        imgUrl: employee.imgUrl,
      })
      .eq('id', id)
      .select()

    if (error) {
      throw new Error(error.message)
    }
    if (!data) {
      throw new Error('no data')
    }
    return data
  } catch (error) {
    console.log(error)
    throw error
  }
}

// @@TODO
export const updateEmployeeAPI = async (employee: Employee, id: number) => {
  try {
    const baseUrl = process.env.NEXT_PUBLIC_BASE_URL as string
    const response = await fetch(
      baseUrl + `/api/update-employee/${id}`,
      APIOptionsPOST(employee),
    )
    if (response.status >= 400) {
      console.log('updateEmployeeAPI error: status: ', response.status)
      const message = `${response.status} ${response.statusText}`
      throw new Error(message)
    } else {
      console.log('response=', response)
      const result = (await response.json()) as Employee
      console.log('response.json=', result)
      return result
    }
  } catch (error) {
    console.log(error)
    throw error
  }
}

// OK
export const deleteEmployee = async (id: number) => {
  try {
    const { data, error } = await createClient()
      .from('employees')
      .delete()
      .eq('id', id)
      .select()

    if (error) {
      throw new Error(error.message)
    }
    if (!data) {
      throw new Error('no data')
    }
    return { success: !error }
    //return data
  } catch (error) {
    console.log(error)
    throw error
  }
}

// @@TODO
export const deleteEmployeeAPI = async (id: number) => {
  try {
    const baseUrl = process.env.NEXT_PUBLIC_BASE_URL as string
    const response = await fetch(
      baseUrl + `/api/delete-employee/${id}`,
      APIOptionsGET(),
    )

    if (response.status >= 400) {
      console.log('deleteEmployeeAPI error: status: ', response.status)
      const message = `${response.status} ${response.statusText}`
      throw new Error(message)
    } else {
      console.log('response=', response)
      const result = (await response.json()) as Array<Employee>
      console.log('response.json=', result)
      return result
    }
  } catch (error) {
    console.log(error)
    throw error
  }
}

// @@TODO
export const deleteEmployeeList = async (ids: number[]) => {
  try {
    const { data, error } = await createClient()
      .from('employees')
      .delete()
      .in('id', ids)
      .select()

    if (error) {
      throw new Error(error.message)
    }
    if (!data) {
      throw new Error('no data')
    }
    return { success: !error }
    //return data
  } catch (error) {
    console.log(error)
    throw error
  }
}

// @@TODO: deleteEmployeeListAPI

// OK
export const createEmployee = async (employee: Employee) => {
  try {
    const { data, error } = await createClient()
      .from('employees')
      .insert([
        {
          name: employee.name,
          title: employee.title,
          status: employee.status,
          age: employee.age,
          role: employee.role,
          imgUrl: employee.imgUrl,
        },
      ])
      .select()

    if (error) {
      throw new Error(error.message)
    }
    if (!data) {
      throw new Error('no data')
    }
    return data
  } catch (error) {
    console.log(error)
    throw error
  }
}

// @@TODO
export const createEmployeeAPI = async (
  uri: URL | RequestInfo,
  employee: Employee,
) => {
  try {
    const response = await fetch(uri, APIOptionsPOST(employee))
    const { data, error } = (await response.json()) as {
      data: Employee[]
      error: string
    }
    if (error) {
      const message = `Error in getEmployeesAPI - status=${response.status} - error=${error}`
      throw new Error(message)
    }
    if (!data) {
      throw new Error('no data')
    }
    return data
  } catch (error) {
    console.log(error)
    throw error
  }
}

// OK
export const getEmployees = async () => {
  try {
    const { data, error } = await createClient().from('employees').select()

    if (error) {
      console.log('error=', error)
      throw new Error(error.message)
    }
    if (!data) {
      throw new Error('no data')
    }
    return data as Employee[]
  } catch (error) {
    console.log(error)
    throw error
  }
}

// OK
export const getEmployeesAPI = async (uri: URL | RequestInfo) => {
  try {
    const response = await fetch(uri, APIOptionsGET())

    console.log('getEmployeesAPI() response=', response)

    const { data, error } = (await response.json()) as {
      data: Employee[]
      error: string
    }
    if (error) {
      const message = `Error in getEmployeesAPI - status=${response.status} - error=${error}`
      throw new Error(message)
    }
    if (!data) {
      throw new Error('no data')
    }
    return data
  } catch (error) {
    console.log(error)
    throw error
  }
}

// OK
export const getEmployee = async (id: number) => {
  try {
    const { data, error } = await createClient()
      .from('employees')
      .select()
      .eq('id', id)
      .select()

    if (error) {
      throw new Error(error.message)
    }
    // NOTE: This will never occur.
    if (!data) {
      throw new Error('no data')
    }
    return data[0] as Employee // @@TODO: Should be single, not array.
  } catch (error) {
    console.log(error)
    throw error
  }
}

// @@TODO
export const getEmployeeAPI = async (uri: URL | RequestInfo) => {
  try {
    const response = await fetch(uri, APIOptionsGET())
    const { data, error } = (await response.json()) as {
      data: Employee
      error: string
    }
    if (error) {
      const message = `Error in getEmployeeAPI - status=${response.status} - error=${error}`
      throw new Error(message)
    }
    if (!data) {
      throw new Error('no data')
    }
    return data
  } catch (error) {
    console.log(error)
    throw error
  }
}
